import IconButton from "../../../../components/icon-button";
import { TrashIcon } from "@heroicons/react/24/outline";
import { useActionState, useEffect } from "react";
import { deleteChild } from "../actions/children";
import { PhysicalAndMentalSymptom } from "../../../../models";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

export function DeleteChildButton({ item }: { item: PhysicalAndMentalSymptom }) {
  const navigate = useNavigate();

  const deleteWithId = deleteChild.bind(null, item.id!);
  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    if (!window.confirm("Are you sure you want to delete this symptom?")) {
      e.preventDefault();
    }
  }
  const [state, formAction, isPending] = useActionState(deleteWithId, {
    success: false,
    message: "",
  });

  useEffect(() => {
    if (state.success) {
      toast.success("Symptom deleted successfully");
      navigate(`/admin/physical-and-mental-symptoms/edit/${item.parentId}?reload=${Date.now()}`, { replace: true });
    }
  }, [state]);

  return (
    <form action={formAction} onSubmit={handleSubmit}>
      <IconButton label="Delete" icon={TrashIcon} loading={isPending}/>
    </form>
  );
}


